import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "list mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "list-loading"
}
const _hoisted_3 = { cols: "12" }
const _hoisted_4 = ["rowspan", "colspan"]
const _hoisted_5 = {
  class: "column-space",
  colspan: "1"
}
const _hoisted_6 = {
  class: "column-space",
  colspan: "2"
}
const _hoisted_7 = {
  class: "column-space",
  colspan: "1"
}
const _hoisted_8 = {
  class: "column-space",
  colspan: "1"
}
const _hoisted_9 = {
  class: "column-space",
  colspan: "1"
}
const _hoisted_10 = {
  class: "column-space",
  colspan: "1"
}
const _hoisted_11 = {
  class: "column-space",
  colspan: "1"
}
const _hoisted_12 = {
  class: "column-space",
  colspan: "2"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  colspan: "9",
  class: "pt-2",
  style: {"height":"300px","vertical-align":"top"}
}

import searchVehicleResponse from "@/types/responses/getVehicle";
import temperatureInformationSpotResponse from "@/types/responses/temperatureInformationSpot";
import i18n from '@/lang/i18n';

const NUMBER_PLATE_INDEX = 1;
const TEMPERATURE_SENSOR_INDEX = 2;
const SPOT_INDEX = 4;


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicelsTemperatureList',
  props: {
    vehicles: {},
    spots: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const headerListRow1 = [
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.department'),
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.vehicle'),
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.temperature'),
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.dateTime'),
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.sopt'),
];

const headerListRow2 = [
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.ch1'),
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.ch2'),
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.ch3'),
  i18n.global.t('pages.temperatureSensors.informationNumerical.list.header.ch4'),
];
function headerListRow1Rowspan(index: number) {
  if (index == TEMPERATURE_SENSOR_INDEX) return 1;
  return 2;
}

function headerListRow1Colspan(index: number) {
  if (index == NUMBER_PLATE_INDEX || index == SPOT_INDEX) return 2;
  if (index == TEMPERATURE_SENSOR_INDEX) return 4;
  return 1;
}


return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.reading')), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_table, {
      "fixed-header": true,
      density: "comfortable"
    }, {
      default: _withCtx(() => [
        _createElementVNode("thead", _hoisted_3, [
          _createElementVNode("tr", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headerListRow1, (listItem, index) => {
              return _createElementVNode("th", {
                key: index,
                rowspan: headerListRow1Rowspan(index),
                colspan: headerListRow1Colspan(index),
                class: "text-center",
                style: {"background-color":"#f8f9fa"}
              }, [
                _createElementVNode("div", null, _toDisplayString(listItem), 1)
              ], 8, _hoisted_4)
            }), 64))
          ]),
          _createElementVNode("tr", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headerListRow2, (listItem, index) => {
              return _createElementVNode("th", {
                key: index,
                class: "text-center",
                style: {"background-color":"#f8f9fa"}
              }, [
                _createElementVNode("div", null, _toDisplayString(listItem), 1)
              ])
            }), 64))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (props.vehicles?.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.vehicles, (vehicle) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: vehicle.id
                }, [
                  _createElementVNode("td", _hoisted_5, _toDisplayString(vehicle.department?.name), 1),
                  _createElementVNode("td", _hoisted_6, _toDisplayString(vehicle.number_plate), 1),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(vehicle.ch1), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(vehicle.ch2), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(vehicle.ch3), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(vehicle.ch4), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(vehicle.datetime), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(vehicle.spot_name), 1)
                ]))
              }), 128))
            : (!props.vehicles?.length && !__props.isLoading)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                  _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(i18n).global.t('pages.common.list.noData')), 1)
                ]))
              : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})